import { generateIdDecorator, userActionInterceptor } from './user.action.interceptor';
import { SYNC_CONTEXT_SOURCE, CONTEXT_SOURCE, USER_TYPE } from './const';
import { container } from './container';
import Emitter from 'tiny-emitter';
const SCROLL = 'scroll';
@generateIdDecorator(function () {
  return this.instanceId + '_ScrollSync';
})
class ScrollSync extends Emitter {
  constructor (instanceId, el) {
    super();
    if(!el) {
      return;
    }
    this.instanceId = instanceId;
    this.el = el;
    this.scrollActions = [];
    this.scroll = this.scroll.bind(this);
    el.removeEventListener('scroll',this.scroll,false);
    el.addEventListener('scroll',this.scroll,false);
    this.sendScrollPosition = this.sendScrollPosition.bind(this);
    this.on(SCROLL, this.sendScrollPosition);
  }
  scroll () {
    let el = this.el;
    let width = el.scrollWidth;
    let left = el.scrollLeft;
    let height = el.scrollHeight;
    let top = el.scrollTop;
    this.emit(SCROLL, left, width, top, height);
  }
  disableScroll () {
    const syncContext = container.get(SYNC_CONTEXT_SOURCE);
    if (syncContext && syncContext.getContextSource() === CONTEXT_SOURCE.REMOTE && syncContext.userType === USER_TYPE.SALES) {
      this.el.style.overflow = 'hidden';
    }
    this.el.removeEventListener('scroll',this.scroll,false);
  }
  enableScroll () {
    let el = this.el;
    if (this.scrollTimer) {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }
    this.scrollTimer = setTimeout(() => {
      el.style.overflow = 'auto';
      el.addEventListener('scroll',this.scroll,false);
      this.scrollTimer = null;
    }, 300);
  }

  setScrollPosition (left, width, top, height) {
    let el = this.el;
    this.disableScroll();
    let jWidth = el.scrollWidth;
    let jHeight = el.scrollHeight;
    let scrollLeft = left * jWidth / width;
    let scrollTop = top * jHeight / height;
    el.scrollLeft = scrollLeft;
    el.scrollTop = scrollTop;
    this.enableScroll();
  }
  @userActionInterceptor({ methodName: 'setScrollPosition' })
  sendScrollPosition (left, width, top, height) {
    console.log(left, width, top, height);
  }
  destroy () {
    this.el.removeEventListener('scroll',this.scroll,false);
  }
}

export { ScrollSync };
